export default __webpack_public_path__ + "static/media/logo.1b972ab4.svg";